import { TriggerSpine } from 'core/display/spines/TriggerSpine'

export default class makeTriggerSpine extends PIXI.Container{
  constructor(data) {
    super()
    const triggerSpine = new TriggerSpine(data, this)
    this.addChild(triggerSpine)
    triggerSpine.setToSetupPose()
  }
}
